import Vue from "vue";
import HeaderView from "../components/header/view.vue";
import LoginPopup from "../components/login/login-popup.vue";

Vue.component(HeaderView.name,HeaderView);
Vue.component(LoginPopup.name,LoginPopup);



// WEBPACK FOOTER //
// ./src/common/components.js